export const GENERAL_SEARCH = 'GENERAL_SEARCH';
export const CLEAR_GENERAL_SEARCH = 'CLEAR_GENERAL_SEARCH';
export const ORDERS_SEARCH = 'ORDERS_SEARCH';
export const CLIENTS_SEARCH = 'CLIENTS_SEARCH';
export const COMMUNICATIONS_SEARCH = 'COMMUNICATIONS_SEARCH';
export const NOTES_SEARCH = 'NOTES_SEARCH';
export const MESSAGES_SEARCH = 'MESSAGES_SEARCH';

export const SELECT_SEARCH_ORDER = 'SELECT_SEARCH_ORDER';
export const SELECT_SEARCH_CLIENT = 'SELECT_SEARCH_CLIENT';
export const SELECT_SEARCH_COMMUNICATION = 'SELECT_SEARCH_COMMUNICATION';
export const SELECT_SEARCH_NOTE = 'SELECT_SEARCH_NOTE';
export const SELECT_SEARCH_MESSAGE = 'SELECT_SEARCH_MESSAGE';

export const SEARCH_ORDERS_SUCCESS = 'SEARCH_ORDERS_SUCCESS';
export const SEARCH_ORDERS_FAILURE = 'SEARCH_ORDERS_FAILURE';

export const SEARCH_CLIENTS_SUCCESS = 'SEARCH_CLIENTS_SUCCESS';
export const SEARCH_CLIENTS_FAILURE = 'SEARCH_CLIENTS_FAILURE';

export const SEARCH_COMMUNICATIONS_SUCCESS = 'SEARCH_COMMUNICATIONS_SUCCESS';
export const SEARCH_COMMUNICATIONS_FAILURE = 'SEARCH_COMMUNICATIONS_FAILURE';

export const SEARCH_NOTES_SUCCESS = 'SEARCH_NOTES_SUCCESS';
export const SEARCH_NOTES_FAILURE = 'SEARCH_NOTES_FAILURE';

export const SEARCH_MESSAGES_SUCCESS = 'SEARCH_MESSAGES_SUCCESS';
export const SEARCH_MESSAGES_FAILURE = 'SEARCH_MESSAGES_FAILURE';

export const generalSearch = ({ query, pageSize }) => ({
  type: GENERAL_SEARCH,
  payload: { query, pageSize },
});

export const ordersSearch = ({ query, pageSize }) => ({
  type: ORDERS_SEARCH,
  payload: { query, pageSize },
});

export const clientsSearch = ({ query, pageSize }) => ({
  type: CLIENTS_SEARCH,
  payload: { query, pageSize },
});

export const communicationsSearch = ({ query, pageSize }) => ({
  type: COMMUNICATIONS_SEARCH,
  payload: { query, pageSize },
});

export const notesSearch = ({ query, pageSize }) => ({
  type: NOTES_SEARCH,
  payload: { query, pageSize },
});

export const messagesSearch = ({ query, pageSize }) => ({
  type: MESSAGES_SEARCH,
  payload: { query, pageSize },
});

export const selectSearchOrder = ({ clientId, history }) => ({
  type: SELECT_SEARCH_ORDER,
  payload: { clientId, history },
});

export const selectSearchClient = ({ clientId, history }) => ({
  type: SELECT_SEARCH_CLIENT,
  payload: { clientId, history },
});

export const selectSearchCommunication = ({ ticketId, chainId, history }) => ({
  type: SELECT_SEARCH_COMMUNICATION,
  payload: { ticketId, chainId, history },
});

export const selectSearchNote = ({ ticketId, history }) => ({
  type: SELECT_SEARCH_NOTE,
  payload: { ticketId, history },
});

export const selectSearchMessage = ({ ticketId, chainId, history }) => ({
  type: SELECT_SEARCH_MESSAGE,
  payload: { ticketId, chainId, history },
});
